module.exports = __webpack_public_path__ + "static/media/ooppah_ilustracao_mensagens.defb7880.png";